/* eslint react/no-unused-state: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { CarvanaProvider, CarvanaConsumer } from './Provider';

const ProviderWithRenderProp = ({
  useProvider,
  render,
  environment,
  isLoggedInExternally,
  shouldRefreshProfile,
  headerContext,
  favorites
}) => {
  return useProvider ? (
    <CarvanaProvider
      environment={environment}
      isLoggedInExternally={isLoggedInExternally}
      shouldRefreshProfile={shouldRefreshProfile}
      headerContext={headerContext}
    >
      <CarvanaConsumer>
        {context => {
          const providerProps = {
            profile: context.profile,
            favorites: {
              favorites: favorites.favorites ?? context.favorites,
              removeFavorite: favorites.removeFavorite ?? context.removeFavorite
            }
          };
          return render(providerProps);
        }}
      </CarvanaConsumer>
    </CarvanaProvider>
  ) : (
    render({})
  );
};

ProviderWithRenderProp.propTypes = {
  render: PropTypes.func.isRequired,
  environment: PropTypes.string.isRequired,
  headerContext: PropTypes.shape({}).isRequired,
  useProvider: PropTypes.bool,
  isLoggedInExternally: PropTypes.bool,
  shouldRefreshProfile: PropTypes.bool,
  favorites: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})),
    removeFavorite: PropTypes.func
  })
};

ProviderWithRenderProp.defaultProps = {
  useProvider: false,
  isLoggedInExternally: false,
  shouldRefreshProfile: false
};

export default ProviderWithRenderProp;
